import { createAction } from '@reduxjs/toolkit';
export const graphQLFetchTasksSucceeded = createAction('graphQLFetchTasksSucceeded');
export const graphQLFetchTasksFailed = createAction('graphQLFetchTasksFailed');